import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { homeRedirectRoute } from '@atlassian/jira-router-routes-home-redirect-routes/src/homeRedirectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import JiraBaseRedirect from './common/ui/redirect/jira-base-redirect/index.tsx';

export const homeRedirectRouteEntry: Route = createEntry(homeRedirectRoute, () => ({
	group: 'home',
	component: JiraBaseRedirect,
	layout: globalLayout,
	resources: [...getNavigationResources()],
	isRedirect: true,
	forPaint: [LazyAtlassianNavigation],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-home-redirect-entries/src/homeRedirectRouteEntry.tsx',
			whichExportToUse: 'homeRedirectRouteEntry',
		},

		enabled: true,
	},
}));
